<template>
    <div id="classask"
         class="error-task">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="back">
                    <i class="icon-fanhui"></i>
                </span>
                第{{qnumber}}题
            </div>
        </div>
        <div v-if="loading">
            <div class="nodata"
                 v-if="Object.keys(questions).length=='0'">
                <span class="icon-meiyoufabushijuan"></span>
                <p>没有作业数据</p>
            </div>
            <div class="wrap"
                 v-else>
                <div class="question"
                     v-show="questions">
                    <div class="q_content"
                         v-if="content.length">
                        <h3>{{questions.re_name}}</h3>
                        <p v-html="c"
                           v-for="c in content"
                           class="q_text"></p>
                    </div>
                    <p class="title"
                       v-if="questions.rd_titledry">
                        <span v-html="questions.rd_titledry"></span>
                    </p>

                    <div class="img-wrap">
                        <img :src="questions.image"
                             v-if="questions.image && questions.image.url" />
                    </div>
                    <!-- 选择题 -->
                    <div class="check_choose">
                        <div :class="[indexText[index]==questions.rd_trueoption?'choose_opation active clearfix':'choose_opation clearfix']"
                             v-for="(item,index) in questions.rd_options">
                            <i class="option"
                               v-if='index==0'>A</i>
                            <i class="option"
                               v-if='index==1'>B</i>
                            <i class="option"
                               v-if='index==2'>C</i>
                            <i class="option"
                               v-if='index==3'>D</i>
                            <span style="background: transparent;"
                                  v-html='item'></span>
                            <p class="choose_img_pic"
                               v-if="item.image">
                                <img :src="item.image"
                                     alt="">
                            </p>
                        </div>
                        <div class="sentence"
                             v-if="questions.rd_analysisprocess">
                            解析：
                            <div v-html="questions.rd_analysisprocess"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="wrong_names">
                <div class="content"
                     v-if="wrong_names.length">
                    <div class="title">答错
                        <span>{{wrong_names.length}}</span>人
                    </div>
                    <div class="name">
                        <span v-for="name in wrong_names">{{name}}</span>
                    </div>
                </div>
                <div class="content"
                     v-else>
                    <div class="title">答错
                        <span>0</span>人
                    </div>
                    <div class="name">
                        <span v-for="name in wrong_names"></span>
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            classid: this.$route.params.classid,
            taskid: this.$route.params.taskid,
            rdid: this.$route.query.rdid,
            qnumber: this.$route.query.qnumber,
            questions: [],
            wrong_names: [],
            indexText: ["A", "B", "C", "D"],
            loading: false,
            content: [],
        }
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
    },
    created () {
        this.$http.post(API_URL_TASK_API + '/chinese/check/reading/task/wrong', {
            "message_id": this.taskid,
            "rd_id": this.rdid,
            "unit_class_id": this.classid
        }).then(res => {
            res = res.data;
            this.loading = true;
            if (res.response == "ok") {
                this.wrong_names = res.data.wrong_stu
                this.questions = res.data.question_data;
                let _content = this.questions.re_content;
                this.content = _content.split('||');
            }
        });
    },
    destroyed () {
    },
    components: {
        loadingS,
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.error-task {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url(../img/choose_back.png) 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}

.content {
    background-color: $c-fbg;
    .title {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 36px / $ppr;
        padding: 0 $w;
        border-bottom: 1px / $ppr solid $line;
        font-weight: 600;
        span {
            //color: $c-danger;
        }
    }
    .name {
        padding: $w $w;
        display: flex;
        flex-wrap: wrap;
        min-height: 200px / $ppr;
        span {
            width: 25%;
            font-size: 30px / $ppr;
            color: #333;
            margin: 12px / $ppr 0;
        }
    }
}

/*.nodata {
      color: $c-light;
      margin-top: 50px/$ppr;
      margin-bottom: 50px/$ppr;
      text-align: center;
      span {
          display: inline-block;
          color: $c-litgray;
          font-size: 110px/$ppr;
          margin-bottom: 36px/$ppr;
      }
  }*/

.question {
    margin-bottom: 24px / $ppr;
    .q_content {
        background-color: $c-fbg;
        margin-bottom: 24px / $ppr;
        padding: $w $w;
        line-height: 50px / $ppr;
        h3 {
            text-align: center;
            padding-bottom: 10px / $ppr;
        }
        .q_text {
            text-indent: 2em;
        }
    }
    .title {
        background-color: $c-fbg;
        padding: $w $w;
    }
    .img-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        img {
            display: inline-block;
        }
    }
}

.question .option:last-child {
    border: 0 !important;
}

.check_choose {
    background-color: #fff;
    .choose_title {
        p {
            padding: 32px / $ppr 24px / $ppr;
            border-top: 1px / $ppr solid #e8e8e8;
            &:first-child {
                border-top: none;
            }
        }
    }
    .stem {
        line-height: 50px / $ppr;
        border-top: 1px / $ppr solid #e8e8e8;
    }
    .choose_opation {
        position: relative;
        padding: 32px / $ppr 24px / $ppr 32px / $ppr 96px / $ppr;
        border-top: 1px / $ppr solid #e8e8e8;
        &.active {
            color: #fff;
            .option {
                background: #66cc22;
            }
            span {
                color: #66cc22;
            }
        }
        .option {
            display: block;
            position: absolute;
            top: 50%;
            left: 24px / $ppr;
            margin-top: -24px / $ppr;
            width: 48px / $ppr;
            height: 48px / $ppr;
            line-height: 48px / $ppr;
            text-align: center;
            border-radius: 48px / $ppr;
            border: 1px / $ppr solid #dcdcdc;
        }
    }
    .sentence {
        padding: 32px / $ppr 24px / $ppr;
        color: #66cc22;
        border-top: 1px / $ppr solid #e8e8e8;
    }
}
</style>
